export default "__VITE_ASSET__DowXZI0N__"